import React, {
  memo,
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Grid,
  Box,
  Typography,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import configServ from "../../../services/config";
import { useDispatch, useSelector } from "react-redux";
import { triggerLoader } from "../../../redux/reducers/LoaderTrigger";
import CircularProgress from "@mui/material/CircularProgress";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const CustomerDetails = forwardRef(
  ({ onUserSelect, diagnosisData, loadingg, editData }, ref) => {
    const [selectedUserId, setSelectedUserId] = useState("");
    const [userDetails, setUserDetails] = useState(null);
    const [customerList, setCustomerList] = useState([]);
    const { company_id } = useSelector((state) => state.GlobalVariables);
    const [isExpanded, setIsExpanded] = useState(false);

    useImperativeHandle(ref, () => ({
      handleReset,
    }));
    const dispatch = useDispatch();

    const fetchCustomerList = async () => {
      try {
        const dataToSend = {
          company_id: company_id,
          search_by: null,
          search: null,
          per_page: null,
          page: null,
        };
        const res = await configServ.getCustomerList(dataToSend);
        if (res.status === 200) {
          setCustomerList(res.data);
        }
      } catch (err) {
        console.log("Failed to fetch customer list", err);
      }
    };

    useEffect(() => {
      dispatch(triggerLoader());
      if (diagnosisData?.customer_id && customerList.length > 0) {
        setSelectedUserId(diagnosisData.customer_id);
      }
      dispatch(triggerLoader());
    }, [diagnosisData, customerList]);

    useEffect(() => {
      dispatch(triggerLoader());
      if (editData?.user_id && customerList.length > 0) {
        setSelectedUserId(editData.user_id);
      }
      dispatch(triggerLoader());
    }, [editData, customerList]);

    console.log("diagnosisData", diagnosisData);
    console.log("editData", editData);

    // console.log("userdata=",editData)

    useEffect(() => {
      fetchCustomerList();
    }, []);

    useEffect(() => {
      if (selectedUserId) {
        const selectedUser = customerList.find((u) => u.id === selectedUserId);
        if (selectedUser) {
          setUserDetails(selectedUser);
          onUserSelect(selectedUser.id);
        }
      } else {
        setUserDetails(null);
      }
    }, [selectedUserId, customerList, onUserSelect]);

    const handleReset = () => {
      setSelectedUserId("");
      setUserDetails(null);
      onUserSelect(null);
    };

    return (
      <Box>
        {/* <Typography variant="h6" gutterBottom>
          Select Customer
        </Typography> */}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              {loadingg ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 56,
                    backgroundColor: "white",
                    border: "1px solid #c4c4c4",
                    borderRadius: 1,
                  }}
                >
                  <CircularProgress size={24} />
                </Box>
              ) : (
                <Autocomplete
                  options={customerList}
                  getOptionLabel={(option) => option.fname || ""}
                  value={
                    customerList.find((user) => user.id === selectedUserId) ||
                    null
                  }
                  onChange={(event, newValue) =>
                    setSelectedUserId(newValue ? newValue.id : "")
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Select Customer" />
                  )}
                  sx={{ backgroundColor: "white" }}
                />
              )}
            </FormControl>
          </Grid>
          {userDetails && (
            <Accordion
              expanded={isExpanded}
              onChange={() => setIsExpanded(!isExpanded)}
              sx={{
                backgroundColor: "white",
                mt: 2,
                ml: 1, // start-align
                width: isExpanded
                  ? "100%"
                  : { xs: "100%", sm: "100%", md: "50%" },
                boxShadow: 1,
                borderRadius: 2,
                transition: "width 0.3s ease",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6" color="primary">
                  Customer Details
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={4} md={2}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Age
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {userDetails.age || "—"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Height (cm)
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {userDetails.height || "—"}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Weight (kg)
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {userDetails.weight || "—"}
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
      </Box>
    );
  }
);

export default CustomerDetails;
